import { Injectable } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

@Injectable({
    providedIn: 'root',
})
export class MatMenuService {
    private currentlyOpenedTrigger: MatMenuTrigger | null = null;
    private timeOutTracker: ReturnType<typeof setTimeout> | undefined;
    public readonly timeOut = 150;

    /**
     * Opens the menu and manages the state of the currently opened menu.
     * @param trigger the menu trigger being hovered over
     */
    openMenu(trigger: MatMenuTrigger) {
        if (
            this.currentlyOpenedTrigger &&
            this.currentlyOpenedTrigger !== trigger
        ) {
            this.currentlyOpenedTrigger.closeMenu();
        }

        if (this.timeOutTracker) {
            clearTimeout(this.timeOutTracker);
        }

        this.currentlyOpenedTrigger = trigger;
        trigger.openMenu();
    }

    /**
     * Closes the menu after a specified timeout to allow for navigation between menu items.
     * @param trigger the menu trigger being hovered over
     */
    closeMenuWithDelay(trigger: MatMenuTrigger) {
        this.timeOutTracker = setTimeout(() => {
            trigger.closeMenu();
            this.currentlyOpenedTrigger = null;
        }, this.timeOut);
    }
}
